import * as ng from 'angular';
import { ArchiSmallServices } from '../services/archismall.service';
import { PreviewService } from '../services/preview.service';
import { CheckBrowserPluginsService } from '../services/check-browser-plugins.service';
import { googleAPI } from '../third/googleAPI';

class PreviewModalController implements ng.IController {

  static $inject: string[] = [
    '$rootScope',
    '$scope',
    'PreviewService',
    'CheckBrowserPluginsService',
    '$q',
    'ArchiSmallServices'
  ];

  private type: any;
  private path: any;
  private close: any;

  constructor(
    private $rootScope: any, // ng.IRootScopeService,
    private $scope: any,
    private PreviewService: PreviewService,
    private CheckBrowserPlugins: CheckBrowserPluginsService,
    private $q: any,
    private ArchiSmallServices: ArchiSmallServices
  ) {
    this.type = $scope.$parent.$resolve.type;
    this.path = $scope.$parent.$resolve.path;
    $scope.isPDF = false;
    $scope.isLoading = false;
    $scope.alertMessage = '';

    if (this.type === 'pdf') {

      if (CheckBrowserPlugins.hasPDFReaderInstalled()) {
        this.type = 'pdf';
        $scope.isPDF = true;
      } else {
        this.type = 'img';
      }
      if (!$scope.isPDF) {
        $scope.alertMessage = 'Il tuo browser non supporta il preview dei file PDF. Per questo motivo verrà visualizzata soltanto la prima pagina del documento.';
      }
    }

    $scope.mainType = this.type;

    $scope.getPreview = () => {
      $scope.isLoading = true;
      PreviewService.getPath(this.path, this.type)
        .then((result: any) => {
          // console.log(result);

          $scope.type = result.data.type;
          $scope.responseType = result.data.responseType;
          $scope.filePreview = $scope.responseType === 'xml' ? atob(result.data.filePreview) : result.data.filePreview;
          if ($scope.responseType === 'url') {
            $scope.createPathWithValidToken();
          } else {
            $scope.isLoading = false;
          }
        }, (error) => {
          $q.reject(error);
          $scope.isLoading = false;
        });
    };

    $scope.getPreview();

    $scope.createPathWithValidToken = () => {
      ArchiSmallServices.validateGoogleAPIToken(googleAPI.getAccessToken())
        .then((response: any) => {
          let googleAPIToken = googleAPI.getAccessToken();
          $scope.filePreview = $scope.filePreview + '?access_token=' + googleAPIToken;
          $scope.filePreview = PreviewService.getStoragePath($scope.filePreview);
          $scope.isLoading = false;
        }, (error) => {
          ArchiSmallServices.getGoogleAPIToken()
            .then((response: any) => {
              googleAPI.setAccessToken(response.accessToken);
              let googleAPIToken = googleAPI.getAccessToken();
              $scope.filePreview = $scope.filePreview + '?access_token=' + googleAPIToken;
              $scope.filePreview = PreviewService.getStoragePath($scope.filePreview);
              $scope.isLoading = false;
            }, (error) => {
              $rootScope.alert('error', error);
              $scope.isLoading = false;
            });
        });
    };

    $scope.cancel = () => {
      this.close();
    };
  }
}


export const PreviewModalComponent: ng.IComponentOptions = {
  template: require('./preview-modal.html'),
  controller: PreviewModalController,
  bindings: {
    close: '&'
  }
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/preview-modal/preview-modal.ts